// Interfaces
import { IRouteParent } from 'routes/route.interface'

// Constant
import { USER_MODULE, USER_URL } from 'constant/url.constant'
import { ACCESS_CODE_USER_MANAGEMENT } from 'constant/access.constant'

// User Management (Waiting Approval + Approved + Rejected)
import { userWaitingApprovalRoutes } from './user-waiting-approval.router'
import { userApprovedRoutes } from './user-approved.router'
import { userRejectedRoutes } from './user-rejected.router'
import { userDetailRoutes } from './user-detail.router'

const userRoutes: IRouteParent = {
  path: USER_URL.WAITING_APPROVAL,
  meta: {
    attrs: {
      module: USER_MODULE,
      icon: 'back-office/icon-users',
      label: 'backOffice.userManagement',
      accessCodes: ACCESS_CODE_USER_MANAGEMENT,
    },
  },
  children: [...userWaitingApprovalRoutes, ...userApprovedRoutes, ...userRejectedRoutes, ...userDetailRoutes],
}
export { userRoutes }
